import { Weight } from '@/api';

export type WeightUnit = 'gram' | 'kilogram';

const getWeightInUnit = (weight: Weight, unit: Weight['unit']): Weight => ({
  amount:
    weight.unit === 'gram' && unit === 'kilogram'
      ? weight.amount / 1000
      : weight.unit === 'kilogram' && unit === 'gram'
        ? weight.amount * 1000
        : weight.amount,
  unit,
});

export const sumWeights = (weights: (Weight | null)[], unit?: Weight['unit']): Weight => {
  const nonNullWeights = weights.filter((weight) => !!weight);
  const sumUnit =
    unit ??
    ((!!nonNullWeights.length && nonNullWeights.every((weight) => weight.unit === 'gram')
      ? 'gram'
      : 'kilogram') satisfies Weight['unit']);

  return nonNullWeights.reduce(
    (acc, current) => {
      acc.amount += getWeightInUnit(current, sumUnit).amount;

      return acc;
    },
    { amount: 0, unit: sumUnit }
  );
};

export const WEIGHT_UNIT_LABELS = { gram: 'g', kilogram: 'kg' };
export const WEIGHT_UNIT_MAXIMUM_FRACTION_DIGITS = { gram: 4, kilogram: 3 };
